const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";

export const types = {
  //orderDetails
  MISCELLANY_URL_TP_BEGINS: 'MISCELLANY_URL_TP_BEGINS',
  MISCELLANY_URL_TP_SUCCESS: 'MISCELLANY_URL_TP_SUCCESS',
  MISCELLANY_URL_TP_FAILURE: 'MISCELLANY_URL_TP_FAILURE',
};

export const actions = {
  // OrderDetails
  getUrlTp: (data) => ({
    type: types.MISCELLANY_URL_TP_BEGINS,
    payload: data,

  }),
  successGetUrlTp: (data) => ({
    type: types.MISCELLANY_URL_TP_SUCCESS,
    payload: data
  }),
  failureGetUrlTp: (error) => ({
    type: types.MISCELLANY_URL_TP_FAILURE,
    payload: error,
  }),
};

export const initialState = {
  // URL TP
  UrlTP: null,
  UrlTPFetching: false,
  UrlTPError: false,
};

function reducer(state = { ...initialState }, { type, payload }) {
  switch (type) {
    case HYDRATE: {
      const { miscellany } = payload;
      return {
        ...state,
        ...miscellany,
      };
    }

    // URL TP
    case types.MISCELLANY_URL_TP_BEGINS:
      return {
          ...state,
          UrlTP: null,
          UrlTPFetching: true,
          UrlTPError: false,
        }
    case types.MISCELLANY_URL_TP_SUCCESS: {
        return {
            ...state,
            UrlTP: payload,
            UrlTPFetching: false,
            UrlTPError: false,
          }
    }
    case types.MISCELLANY_URL_TP_FAILURE:
        return {
            ...state,
            UrlTP: null,
            UrlTPFetching: false,
            UrlTPError: true,
          }
    default:
      return state;
  }
}

export default reducer;
